<ng-template #generalHeaderTemplate>
  <div class="general-actions-wrapper">
    <button (click)="onCancelChanges()" mat-button class="cancel-changes-button" color="primary" [disabled]="!form.dirty">
      <mat-icon>close</mat-icon>
      {{ "company.topBarButtons.cancelChanges" | translate }}
    </button>
    <button
      mat-raised-button
      class="save-button"
      color="primary"
      [disabled]="!form.dirty || isFormInvalid || isUploadFileInvalid"
      (click)="update()"
    >
      <mat-icon>check</mat-icon>
      {{ "sources.updating-form.update_btn" | translate }}
    </button>
  </div>
</ng-template>

<div class="source-general-wrapper">
  <form [formGroup]="form" class="general-form">
    <div class="general-part">
      <div class="general-tile tile">
        <div class="general-tile-header tile-header">
          <h3 class="title">{{ "sources.General.GeneralTitle" | translate }}</h3>
        </div>

        <div class="general-tile-content tile-content">
          <div class="details-form">
            <div>
              <div>
                <ng-template #slugTemplate>
                  <div>
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="Slug"
                        [readonly]="isUpdateMode()"
                        name="Slug"
                        [required]="true"
                        placeholder="{{ 'sources.fields-placeholders.Slug' | translate }}"
                        [maxLength]="identifierMaxLength"
                      />
                      <mat-error *ngIf="form.get('Slug').errors && form.get('Slug').errors.pattern">
                        {{ "validation.is_not_valid" | translate: { name: ("sources.fields-placeholders.Slug" | translate) } }}
                      </mat-error>
                      <mat-error *ngIf="form.get('Slug').errors && form.get('Slug').errors.required">
                        {{ "validation.required" | translate: { name: ("sources.fields-placeholders.Slug" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </ng-template>

                <mee-permissions-fields-sa-ca
                  *ngIf="isSuperAdmin || isCompanyAdmin; else permissionsForTeamAdmin"
                  [selectedItem]="source"
                  [isUpdateMode]="true"
                  (changePermissionsData)="onChangePermissionsData($event)"
                  [slugFieldTemplateRef]="slugTemplate"
                  [descriptionFieldTemplateRef]="descriptionTemplate"
                ></mee-permissions-fields-sa-ca>

                <ng-template #permissionsForTeamAdmin>
                  <mee-permissions-fields-ta
                    [selectedItem]="source"
                    [isUpdateMode]="true"
                    (changePermissionsData)="onChangePermissionsData($event)"
                    [slugFieldTemplateRef]="slugTemplate"
                    [descriptionFieldTemplateRef]="descriptionTemplate"
                  ></mee-permissions-fields-ta>
                </ng-template>

                <ng-template #descriptionTemplate>
                  <div>
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="Description"
                        name="Description"
                        placeholder="{{ 'sources.fields-placeholders.Description' | translate }}"
                      />
                      <mat-error
                        *ngIf="
                          form.get('Description').errors &&
                          form.get('Description').errors.required &&
                          (form.get('Description').dirty || form.get('Description').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Description" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </ng-template>

                <div class="type-section">
                  <div>
                    <mat-form-field>
                      <input
                        meeRemoveAutofill
                        formControlName="Type"
                        type="text"
                        [placeholder]="'sources.fields-placeholders.Type' | translate"
                        [required]="true"
                        matInput
                        [matAutocomplete]="auto"
                        autocomplete="off"
                      />
                      <mat-autocomplete
                        #auto="matAutocomplete"
                        [displayWith]="displayTypeProperty.bind(this)"
                        (optionSelected)="setTypeValue($event)"
                      >
                        <mat-option *ngFor="let type of typesFiltered | async" [value]="type.type">
                          {{ type.title }}
                        </mat-option>
                      </mat-autocomplete>
                      <mat-error
                        *ngIf="
                          form.get('Type').errors &&
                          form.get('Type').errors.required &&
                          (form.get('Type').dirty || form.get('Type').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Type" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div>
                    <mat-form-field *ngIf="isArcGisType() || isArcGisSceneType()">
                      <mat-select
                        formControlName="Security"
                        [required]="isArcGisType() || isArcGisSceneType()"
                        placeholder="{{ 'sources.fields-placeholders.Security' | translate }}"
                      >
                        <mat-option *ngFor="let type of arcGisSecurityTypes" [value]="type.id">
                          {{ type.translationKey | translate }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          form.get('Security').errors &&
                          form.get('Security').errors.required &&
                          (form.get('Security').dirty || form.get('Security').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Security" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!--For source Type: BIM360-->

                  <ng-container *ngIf="isBim360Type()">
                    <div class="bim-source-fields" *ngIf="isUserAuthorizedInAutodesk">
                      <mat-form-field>
                        <mat-select
                          formControlName="HubId"
                          [required]="true"
                          placeholder="{{ 'sources.fields-placeholders.HubId' | translate }}"
                        >
                          <mat-option *ngFor="let hub of source.IntegrationStatus.AvailableHubs" [value]="hub.Id">
                            {{ hub.Name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field>
                        <mat-select
                          formControlName="ProjectId"
                          [required]="true"
                          placeholder="{{ 'sources.fields-placeholders.ProjectId' | translate }}"
                        >
                          <mat-option *ngFor="let project of availableProjects" [value]="project.Id">
                            {{ project.Name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <ng-container *ngIf="isUpdateMode()">
                      <div class="select-file_selected-models" *ngIf="isDisplaySelectBim360Files">
                        <div class="select-bim360-files">
                          <button
                            type="button"
                            class="select-bim360-files-button"
                            mat-raised-button
                            color="primary"
                            [disabled]="isBim360TreeLoading"
                            (click)="openBim360Tree()"
                          >
                            {{ "sources.fields-placeholders.SelectBim360Files" | translate }}
                          </button>
                          <small class="required-ind" *ngIf="!form.get('SelectedNodes').value">*</small>
                        </div>

                        <div class="selected-models" *ngIf="isShowBim360SelectedModels">
                          <ng-container *ngIf="selectedModelsAmount > 1; else oneModel">
                            <span class="amount-of-models">{{ selectedModelsAmount }} models</span>
                          </ng-container>

                          <ng-template #oneModel>
                            <span class="amount-of-models">{{ selectedModelsAmount }} model</span>
                          </ng-template>

                          selected
                        </div>
                      </div>

                      <div class="autodesk-account">
                        <mee-autodesk-account
                          [integrationStatus]="source.IntegrationStatus"
                          [companySlug]="source.CompanySlug"
                          [sourceSlug]="source.Slug"
                          [sourceId]="source.Id"
                          (signOutFromAutodesk)="onUpdateDataSource()"
                        ></mee-autodesk-account>
                      </div>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="isPix4dType()">
                    <div class="pix4d">
                      <mat-form-field>
                        <input
                          matInput
                          type="text"
                          formControlName="ClientId"
                          [required]="isPix4dType()"
                          placeholder="{{ 'sources.fields-placeholders.ClientId' | translate }}"
                        />
                      </mat-form-field>

                      <mat-form-field>
                        <input
                          matInput
                          formControlName="ClientSecret"
                          [required]="isPix4dType() && isCreateMode()"
                          type="password"
                          placeholder="{{ 'sources.fields-placeholders.ClientSecret' | translate }}"
                        />
                      </mat-form-field>
                    </div>

                    <ng-container *ngIf="isUpdateMode()">
                      <div class="select-file_selected-models">
                        <div class="select-bim360-files">
                          <button
                            type="button"
                            class="select-bim360-files-button"
                            mat-raised-button
                            color="primary"
                            [disabled]="isPix4dProjectsLoading"
                            (click)="openPix4dTree()"
                          >
                            {{ "sources.fields-placeholders.SelectPix4dFiles" | translate }}
                          </button>
                          <small class="required-ind" *ngIf="!form.get('SelectedProjects').value">*</small>
                        </div>

                        <div class="selected-projects" *ngIf="isShowPix4dSelectedProjects">
                          <ng-container *ngIf="selectedPix4dProjectsAmount > 1; else oneProject">
                            <span class="amount-of-projects">{{ selectedPix4dProjectsAmount }} projects</span>
                          </ng-container>

                          <ng-template #oneProject>
                            <span class="amount-of-projects">{{ selectedPix4dProjectsAmount }} project</span>
                          </ng-template>

                          selected
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>

                  <!-- For source Type: WFS-->

                  <div>
                    <mat-form-field *ngIf="isWFSType()">
                      <mat-select
                        formControlName="Security"
                        [required]="isWFSType()"
                        placeholder="{{ 'sources.fields-placeholders.Security' | translate }}"
                      >
                        <mat-option *ngFor="let type of wfsSecurityTypes" [value]="type.id">
                          {{ type.translationKey | translate }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          form.get('Security').errors &&
                          form.get('Security').errors.required &&
                          (form.get('Security').dirty || form.get('Security').touched)
                        "
                        >{{ "validation.required" | translate: { name: "Security" } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="file-upload-field" *ngIf="isShowFileLoader">
                    <div class="optional-inputs file-uploader">
                      <mee-file-upload-button
                        [file]="file"
                        [existingFileUrl]="file.FileUrl"
                        [mediaType]="mediaType"
                        [hideFileList]="hideFileList"
                        (uploaded)="onFileChange($event)"
                        (removeRequiredFile)="onRemoveRequiredFile('File')"
                        (uploadingStatus)="onUploadingFile($event)"
                      >
                        <small data-required-indicator class="required-ind" *ngIf="isRequiredIndicatorVisible">*</small>
                        <div data-requirements-tooltip>
                          <button  class="tooltip" *ngIf="isShapefileType()" [cdkMenuTriggerFor]="menuShapeFile">
                            <span class="label">{{ "sources.Requirements" | translate }}</span>
                            <mat-icon>chevron_right</mat-icon>
                          </button>

                          <ng-template #menuShapeFile>
                            <div class="tooltip-content" cdkMenu>
                              <ul class="instruction-list">
                                <li>{{ "sources.shapefileInstruction.Include" | translate }}</li>
                                <li>{{ "sources.shapefileInstruction.Place" | translate }}</li>
                                <li>{{ "sources.shapefileInstruction.Compress" | translate }}</li>
                                <li>{{ "sources.shapefileInstruction.Upload" | translate }}</li>
                              </ul>
                            </div>
                          </ng-template>
                        </div>
                      </mee-file-upload-button>
                    </div>
                    <p class="option">{{ "commonPhrases.Or" | translate }}</p>

                    <mat-form-field class="cloud-link">
                      <input [formControl]="cloudLinkControl" matInput type="text" placeholder="{{ 'PointClouds.LoadFromCloud' | translate }}" />
                    </mat-form-field>
                  </div>

                  <!-- For Source Type: ArcGis -->
                  <div
                    class="optional-inputs"
                    *ngIf="isArcGisType() || isArcGisSceneType() || isArcGisNtlm()"
                  >
                    <mat-slide-toggle formControlName="IsArcGisOnline" name="IsArcGisOnline" color="primary" (change)="clearSelection()">
                      {{ "sources.fields-placeholders.IsArcGisOnline" | translate }}
                    </mat-slide-toggle>
                  </div>

                  <div class="optional-inputs" [class.hidden]="!isArcGisType()">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="FeatureServiceUrl"
                        name="FeatureServiceUrl"
                        title="{{ form.get('FeatureServiceUrl').value }}"
                        placeholder="{{ 'sources.fields-placeholders.FeatureServiceUrl' | translate }}"
                        [required]="isArcGisType()"
                      />
                      <mat-error
                        *ngIf="
                          form.get('FeatureServiceUrl').errors &&
                          form.get('FeatureServiceUrl').errors.required &&
                          (form.get('FeatureServiceUrl').dirty || form.get('FeatureServiceUrl').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.FeatureServiceUrl" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="optional-inputs" *ngIf="isArcGisSceneType()">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="SceneServiceUrl"
                        name="SceneServiceUrl"
                        title="{{ form.get('SceneServiceUrl').value }}"
                        placeholder="{{ 'sources.fields-placeholders.SceneServiceUrl' | translate }}"
                        [required]="isArcGisSceneType()"
                      />
                      <mat-error
                        *ngIf="
                          form.get('SceneServiceUrl').errors &&
                          form.get('SceneServiceUrl').errors.required &&
                          (form.get('FeatureServiceUrl').dirty || form.get('FeatureServiceUrl').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.SceneServiceUrl" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="optional-inputs" *ngIf="isWFSType()">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="BaseUrl"
                        name="BaseUrl"
                        title="{{ form.get('BaseUrl').value }}"
                        placeholder="{{ 'sources.fields-placeholders.BaseUrl' | translate }}"
                        [required]="isWFSType()"
                      />
                      <mat-error
                        *ngIf="
                          form.get('BaseUrl').errors &&
                          form.get('BaseUrl').errors.required &&
                          (form.get('BaseUrl').dirty || form.get('BaseUrl').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.BaseUrl" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!--For WFS type password-->

                  <div *ngIf="isWFSPassword()">
                    <mat-form-field>
                      <input
                        matInput
                        [type]="'text'"
                        [required]="isWFSPassword()"
                        formControlName="Username"
                        name="Username"
                        autocomplete="off"
                        placeholder="{{ 'sources.fields-placeholders.Username' | translate }}"
                      />
                      <mat-error
                        *ngIf="
                          form.get('Username').errors &&
                          form.get('Username').errors.required &&
                          (form.get('Username').dirty || form.get('Username').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Username" | translate) } }}
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                      <input
                        type="password"
                        matInput
                        [required]="isWFSPassword() && isCreateMode()"
                        formControlName="Password"
                        autocomplete="off"
                        name="Password"
                        meeRemoveAutofill
                        placeholder="{{ 'sources.fields-placeholders.Password' | translate }}"
                      />
                      <mat-error
                        *ngIf="
                          form.get('Password').errors &&
                          form.get('Password').errors.required &&
                          (form.get('Password').dirty || form.get('Password').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Password" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- For Type: Password -->
                  <div *ngIf="isArcGisPassword()">
                    <mat-form-field>
                      <input
                        matInput
                        formControlName="AuthenticationUrl"
                        name="AuthenticationUrl"
                        placeholder="{{ 'sources.fields-placeholders.AuthenticationUrl' | translate }}"
                        [required]="isArcGisPassword()"
                      />
                      <mat-error
                        *ngIf="
                          form.get('AuthenticationUrl').errors &&
                          form.get('AuthenticationUrl').errors.required &&
                          (form.get('AuthenticationUrl').dirty || form.get('AuthenticationUrl').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.AuthenticationUrl" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div *ngIf="isShowUsernamePasswordForArcGis()">
                    <mat-form-field>
                      <input
                        matInput
                        [type]="'text'"
                        [required]="isShowUsernamePasswordForArcGis()"
                        formControlName="Username"
                        name="Username"
                        autocomplete="off"
                        placeholder="{{ 'sources.fields-placeholders.Username' | translate }}"
                      />
                      <mat-error
                        *ngIf="
                          form.get('Username').errors &&
                          form.get('Username').errors.required &&
                          (form.get('Username').dirty || form.get('Username').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Username" | translate) } }}
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                      <input
                        type="password"
                        autocomplete="off"
                        matInput
                        [required]="isShowUsernamePasswordForArcGis() && isCreateMode()"
                        formControlName="Password"
                        meeRemoveAutofill
                        name="Password"
                        placeholder="{{ 'sources.fields-placeholders.Password' | translate }}"
                      />
                      <mat-error
                        *ngIf="
                          form.get('Password').errors &&
                          form.get('Password').errors.required &&
                          (form.get('Password').dirty || form.get('Password').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.fields-placeholders.Password" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- For Type: Token -->

                  <div class="optional-inputs" [class.hidden]="!isArcGisToken()">
                    <mat-form-field>
                      <input
                        type="password"
                        matInput
                        formControlName="Token"
                        autocomplete="off"
                        name="Token"
                        meeRemoveAutofill
                        placeholder="{{ 'sources.details.Token' | translate }}"
                        [required]="isArcGisToken() && isCreateMode()"
                      />
                      <mat-error
                        *ngIf="
                          form.get('Token').errors &&
                          form.get('Token').errors.required &&
                          (form.get('Token').dirty || form.get('Token').touched)
                        "
                        >{{ "validation.required" | translate: { name: ("sources.details.Token" | translate) } }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!--ArcGis Portal-->

                  <div *ngIf="isShowPortalFields()">
                    <div>
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="PortalUrl"
                          name="PortalUrl"
                          placeholder="{{ 'sources.fields-placeholders.PortalUrl' | translate }}"
                        />
                      </mat-form-field>
                    </div>

                    <div>
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="PortalItemId"
                          name="PortalItemId"
                          placeholder="{{ 'sources.fields-placeholders.PortalItemID' | translate }}"
                        />
                      </mat-form-field>
                    </div>
                  </div>

                  <!--ArcGis end portal-->

                  <div class="iModel-inputs" *ngIf="isIModelType() || isIModelGisType()">
                    <div>
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="ProjectName"
                          name="ProjectName"
                          [required]="isIModelType() || isIModelGisType()"
                          placeholder="{{ 'sources.fields-placeholders.ProjectName' | translate }}"
                        />
                        <mat-error *ngIf="form.get('ProjectName').errors && form.get('ProjectName').errors.pattern">
                          {{ "validation.is_not_valid" | translate: { name: ("sources.fields-placeholders.ProjectName" | translate) } }}
                        </mat-error>
                        <mat-error *ngIf="form.get('ProjectName').errors && form.get('ProjectName').errors.required">
                          {{ "validation.required" | translate: { name: ("sources.fields-placeholders.ProjectName" | translate) } }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div>
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="ModelName"
                          name="ModelName"
                          [required]="isIModelType() || isIModelGisType()"
                          placeholder="{{ 'sources.fields-placeholders.ModelName' | translate }}"
                        />
                        <mat-error *ngIf="form.get('ModelName').errors && form.get('ModelName').errors.pattern">
                          {{ "validation.is_not_valid" | translate: { name: ("sources.fields-placeholders.ModelName" | translate) } }}
                        </mat-error>
                        <mat-error *ngIf="form.get('ModelName').errors && form.get('ModelName').errors.required">
                          {{ "validation.required" | translate: { name: ("sources.fields-placeholders.ModelName" | translate) } }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <ng-container *ngIf="isSimpleModelType()">
                    <div class="file-load_instruction">
                      <div class="file-load">
                        <mee-simple-model-file-loader
                          [existingFiles]="simpleModelExistingFiles"
                          (existingFilesChanged)="onSimpleModelExistingFilesChange($event)"
                          (newFilesAdded)="onSimpleModelNewFilesAdded($event)"
                          (uploadingStatus)="onUploadingFile($event)"
                        >
                          <small data-required-indicator class="required-ind with-margin" *ngIf="form.get('NewFiles').value.length === 0">*</small>
                          <div data-requirements-tooltip>
                            <button class="tooltip" [cdkMenuTriggerFor]="menuSimpleModel">
                              <span class="label">{{ "sources.Requirements" | translate }}</span>
                              <mat-icon>chevron_right</mat-icon>
                            </button>

                            <ng-template #menuSimpleModel>
                              <div class="tooltip-content" cdkMenu>
                                <ul class="instruction-list">
                                  <li>{{ "sources.SimpleModelInstruction.SupportedTypes" | translate }}</li>
                                  <li>{{ "sources.SimpleModelInstruction.ZipFile" | translate }}</li>
                                  <li>{{ "sources.SimpleModelInstruction.UseSelectFile" | translate }}</li>
                                </ul>
                              </div>
                            </ng-template>
                          </div>
                        </mee-simple-model-file-loader>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="category-autocomplete">
              <mee-category-autocomplete
                [editModeCategoryName]="editModeCategoryName"
                (categoryCreateDataChanged)="categoryCreateDataChanged($event)"
                (categoryNameChanged)="onCategoryNameChanged($event)"
              ></mee-category-autocomplete>
            </div>
          </div>
        </div>
      </div>

      <div class="script-tile tile">
        <div class="script-tile-header tile-header">
          <h3 class="title">Script</h3>
        </div>

        <div class="script-tile-content tile-content">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    <div class="additional-part">
      <div class="statistic-tile tile">
        <div class="statistic-header tile-header">
          <h3 class="title">{{ "sources.General.StatisticTitle" | translate }}</h3>
          <h4 class="processed">
            {{ "sources.General.Processed" | translate }}
            <span [className]="getProcessedPercentColorClassName(processingStatistic?.ProcessedPercent)">
              {{ processingStatistic?.ProcessedPercent }}
            </span>
          </h4>
        </div>

        <div class="statistic-content tile-content">
          <mee-processing-statistic [statistic]="processingStatistic"></mee-processing-statistic>
        </div>
      </div>

      <div class="data-processing-tile tile">
        <div class="data-processing-header tile-header">
          <h3 class="title">{{ "sources.General.ProcessingData" | translate }}</h3>
        </div>

        <div class="data-processing-content tile-content">
          <div class="scheduling">
            <mee-source-form-scheduling
              [currentSource]="source"
              [isShowScheduling]="isShowScheduling"
              (onChangeScheduleConfiguration)="onChangeScheduleConfiguration($event)"
            >
              <div *ngIf="isArcGisType()">
                <mat-slide-toggle class="toggle" formControlName="IsRealTime" color="primary" (change)="clearSelection()">
                  {{ "sources.fields-placeholders.IsRealTime" | translate }}
                </mat-slide-toggle>
              </div>
            </mee-source-form-scheduling>
          </div>

          <div class="action-buttons">
            <button [disabled]="isProcessingHistoryLoading" mat-raised-button (click)="openProcessingHistory()">
              <span class="text">
                {{ "sources.General.ProcessingHistory" | translate }}
                <mat-spinner *ngIf="isProcessingHistoryLoading" [diameter]="16"></mat-spinner>
              </span>
            </button>
            <button [disabled]="!isProcessingLogs" mat-raised-button (click)="openProcessingLog()">
              {{ "sources.General.ProcessingLog" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="data-collection-mapping tile" *ngIf="isDataCollectionFieldsDisplay">
        <mee-dc-fields-mapping
          [dataCollectionMappingConfiguration]="source.DataCollectionMappingConfiguration"
          (onMappingFieldsChange)="onMappingFieldsChange($event)"
        >
        </mee-dc-fields-mapping>
      </div>
    </div>
  </form>
</div>
